function goSearch() {
    const keyword = document.getElementById('searchInput').value.trim();
    if (keyword) {
        window.location.href = `/search?q=${encodeURIComponent(keyword)}`;
    }
}

function headerSettings() {
    return {
        searchQuery: '',
        showLeftMenu: false,
        isTop: false,
        results: [],
        activeLeftMenu: 'Products',
        aboutData: [],
        productData: [],
        giftData: [],
        showDesktopMenu: false,
        showSubMenu: false,
        hoveredGroup: null,
        girfHoveredGroup: null,
        openMenu(menuName) {
            this.activeLeftMenu = menuName;
            this.showDesktopMenu = true;
            this.shadowShow = true;
        },
        openSubMenu(menuName) {
            this.activeLeftMenu = menuName;
            this.showSubMenu = true;
        },
        goBackToMainMenu() {
            this.showSubMenu = false;
        },
        closeSubMenu() {
            this.hoveredGroup = null;
        },
        openMobileMenu() {
            this.showLeftMenu = true;
            this.showSubMenu = false;
        },
        init() {
            try {
                let element = document.querySelector("#leftMenus");
                this.aboutData = JSON.parse(element.dataset.aboutJson || '[]');
                this.productData = JSON.parse(element.dataset.productJson || '[]');
                this.giftData = JSON.parse(element.dataset.giftJson || '[]');
                this.freeShippingThreshold = Number(parseFloat(element.dataset.freeNum).toFixed(2))
            } catch (error) {
                this.aboutData = [];
                this.productData = [];
                this.giftData = [];
            }
            // 初始化购物车
            this.initializeCart();
        },
        get groupedProducts() {
            const groups = {};
            this.productData.forEach(item => {
                if (item.levelOne && item.levelOne.trim()) {
                    if (!groups[item.levelOne]) {
                        groups[item.levelOne] = {
                            levelOne: item.levelOne,
                            collections: []
                        };
                    }
                    groups[item.levelOne].collections.push(item);
                }
            });
            return Object.values(groups);
        },
        get ungroupedProducts() {
            return this.productData.filter(item => !item.levelOne || !item.levelOne.trim());
        },
        get currentGroupData() {
            if (!this.hoveredGroup) return [];
            return this.productData.filter(item => item.levelOne === this.hoveredGroup);
        },
        toggleSearchModal() {
            document.body.style.overflow = 'hidden';
            // window.removeEventListener("scroll", handleScroll);
            let closeIcon = document.querySelector('#closeSearchDiv');
            let searchIcon = document.querySelector('#openSerachDiv');
            if (searchIcon.classList.contains('opacity-100')) {
                searchIcon.classList.remove('opacity-100');
                searchIcon.classList.add('opacity-0');
                searchIcon.classList.add('translate-y-[-100%]');
                closeIcon.classList.remove('opacity-0');
                closeIcon.classList.add('opacity-100');
                closeIcon.classList.remove('translate-y-[100%]');
                document.body.classList.add('no-scroll');
                const mainNav = document.getElementById("mainNav");
                const mainHeader = document.getElementById("mainHeader");
                const logo = document.getElementById("logoText");
                const icons = document.querySelectorAll(".icon");
                if (mainHeader.classList.contains("bg-transparent")) {
                    this.isTop = true;
                } else {
                    this.isTop = false;
                }
                mainHeader.classList.replace("bg-transparent", "bg-white");
                logo.classList.replace("text-white", "text-black");
                icons.forEach(i => i.classList.replace("text-white", "text-black"));
                mainNav.classList.replace("text-white", "text-black");
                document.querySelector('#searchBox').classList.remove('opacity-0');
                document.querySelector('#searchBox').classList.remove('hidden');
                const cartDrawer = document.querySelector("#cradDrawer");
                const cartDrawerNumber = document.querySelector("#cradDrawerNumber");
                cartDrawer.classList.replace("text-white", "text-black");
                cartDrawerNumber.classList.remove('text-black');
                cartDrawerNumber.classList.add('text-white');
            } else {
                searchIcon.classList.remove('opacity-0');
                searchIcon.classList.add('opacity-100');
                searchIcon.classList.remove('translate-y-[-100%]');
                closeIcon.classList.remove('opacity-100');
                closeIcon.classList.add('opacity-0');
                closeIcon.classList.add('translate-y-[100%]');
                document.body.classList.remove('no-scroll');

                const mainNav = document.getElementById("mainNav");
                const mainHeader = document.getElementById("mainHeader");
                const logo = document.getElementById("logoText");
                const icons = document.querySelectorAll(".icon");
                if (this.isTop) {
                    mainHeader.classList.replace("bg-white", "bg-transparent");
                    if (window.location.pathname == '/') {
                        logo.classList.replace("text-black", "text-white");
                        icons.forEach(i => i.classList.replace("text-black", "text-white"));
                        mainNav.classList.replace("text-black", "text-white");
                        const cartDrawer = document.querySelector("#cradDrawer");
                        const cartDrawerNumber = document.querySelector("#cradDrawerNumber");
                        cartDrawer.classList.replace("text-black", "text-white");
                        cartDrawerNumber.classList.replace('text-white', "text-black")
                    }
                }
                document.querySelector('#searchBox').classList.add('opacity-0');
                document.querySelector('#searchBox').classList.add('hidden');
            }
            // window.addEventListener("scroll", handleScroll);
            document.body.style.overflow = '';
        },
        searchResults() {
            fetch(`/search?q=${this.searchQuery}&view=search`).then(response => response.json()).then(data => {
                this.results = data.results;
            });
        },
        open: false,
        shadowShow: false,
        cartOpen: false,
        freeShippingThreshold: 0.00, // ✅ 可配置免运费额度
        // 购物车相关数据 - 更新部分开始
        cart: {
            items: [],
        },
        cartItemCount: 0,
        cartTotalPrice: 0,
        cartIsOpen: false,
        get cartItemCount() {
            return this.cart.items.reduce((sum, item) => sum + item.quantity, 0);
        },
        // 初始化购物车监听
        initializeCart() {
            // 检查全局购物车store是否存在
            if (typeof window.cartStore !== 'undefined') {
                // 监听全局购物车状态变化
                window.cartStore.addListener((cartStore) => {
                    this.cart.items = cartStore.items;
                    this.cartItemCount = cartStore.itemCount;
                    this.cartTotalPrice = cartStore.totalPrice;
                    this.cartIsOpen = cartStore.isOpen;

                    // 更新阴影显示状态
                    // this.shadowShow = cartStore.isOpen;
                    // this.showCardDrawer();
                });

                // 初始加载购物车数据
                this.cart.items = window.cartStore.items;
                this.cartItemCount = window.cartStore.itemCount;
                this.cartTotalPrice = window.cartStore.totalPrice;
                this.cartIsOpen = window.cartStore.isOpen;
            } else {
                // 如果全局store不存在，使用原有逻辑
                console.warn('Global cart store not found, using local cart state');
            }
        },

        // 更新后的购物车方法
        get totalPrice() {
            // 如果有全局store，使用全局数据，否则使用本地计算
            if (typeof window.cartStore !== 'undefined') {
                return this.cartTotalPrice;
            }
            return this.cart.items.reduce((sum, item) => sum + item.price * item.quantity, 0);
        },

        async removeItem(index) {
            if (typeof window.cartStore !== 'undefined') {
                const item = this.cart.items[index];
                if (item) {
                    this.cart.items[index].removing = true;
                    await window.cartStore.removeItem(item.key);
                }
            } else {
                // 原有逻辑
                this.cart.items.splice(index, 1);
            }
        },

        showCardDrawer() {
            this.shadowShow = true;
            document.querySelector('#cart-sidebar').classList.remove('translate-x-full');
            // if (typeof window.cartStore !== 'undefined') {
            //     window.cartStore.openCart();
            // } else {
            //     // 原有逻辑
            //
            // }
        },

        closeCardDrawer() {
            // if (typeof window.cartStore !== 'undefined') {
            //     window.cartStore.closeCart();
            // } else {
            // 原有逻辑
            this.cartIsOpen = false;
            this.shadowShow = false;
            document.querySelector('#cart-sidebar').classList.remove('translate-x-0');
            document.querySelector('#cart-sidebar').classList.add('translate-x-full');
            // }
        },

        async clearCart() {
            await window.cartStore.clearCart();
            this.cart.items = [];
            // if (typeof window.cartStore !== 'undefined') {
            //
            // } else {
            //     // 原有逻辑
            //
            // }
        }
        // 购物车相关数据 - 更新部分结束
    }
}